<template>
  <div class="">
    <div>
      <!--CANCELLED PAYMENT-->
      <div
        class="d-flex justify-content-center align-items-center error-container"
      >
        <div class="text-center">
          <div>
            <svg
              width="50px"
              height="50px"
              version="1.1"
              viewBox="0 0 1200 1200"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m250.27 1142.2c-51.336 57.754-147.59 57.754-198.93 0-57.754-57.754-57.754-147.59 0-205.35l333.69-340.11-333.69-333.69c-57.754-57.754-57.754-147.59 0-205.35 51.336-57.754 147.59-57.754 198.93 0l340.11 340.11 352.94-352.94c57.754-57.754 147.59-57.754 205.35 0 57.754 51.336 57.754 147.59 0 198.93l-352.94 352.94 352.94 352.94c57.754 57.754 57.754 147.59 0 205.35s-147.59 57.754-205.35 0l-352.94-352.94-340.11 340.11z"
                fill="#0f4c9d"
              />
            </svg>
          </div>
          <div class="faipay-fs">Your Payment Cancelled</div>
          <h5>Something went wrong. Don't worries! Let's try again</h5>
          <div class="text-center mt-4">
            <button @click="goToTypePage" class="btn btn-pink px-5">RETRY</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.small-md {
  font-size: 14px;
}
</style>
<script>


export default {
  data() {
    return {
    };
  },
  beforeMount() {
   
  },
  mounted() {},
  methods: {
    goToTypePage() {
      if(this.$cookies.get('retry_type') == "movie") {
        this.$router.push({
        name: "movie",
        params: {
          movieID: this.$cookies.get('retry_id') ,
          cinemaID: "0",
        }
      });
      } else {
        this.$router.push({
            name: "eventDetails",
            params: {
              eventID:this.$cookies.get('retry_id') 
            }
          });
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/cancel-page.vue